import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './banner.css';

const Banner = ({ text, type, children, ...rest }) => (
  <div className={classNames('zola-ui', 'banner', type)} {...rest}>
    {typeof text === 'string' ? text : children}
  </div>
);

Banner.defaultProps = {
  type: 'informational',
};

Banner.propTypes = {
  text: PropTypes.string,
  type: PropTypes.oneOf(['informational', 'error', 'warning', 'marketing']),
  children: PropTypes.node,
};

export default Banner;
